import { jsx as _jsx } from "react/jsx-runtime";
import imageUrls from '../images/imageUrls';
import { useRedirects } from '../signup-completed-redirection/useRedirects';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const ManualLoginView = () => {
  const {
    redirectGettingStartedUserGuide
  } = useRedirects();
  const errorKey = ErrorKey.LoginFailed;
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    imageURL: imageUrls.door,
    onSentenceWithLinkClick: redirectGettingStartedUserGuide
  });
};

export default ManualLoginView;